<template>
  <v-expansion-panel-content>
    <template v-slot:header>
      <h6 class="title">
        <v-icon
          class="mr-2"
        >
          insert_drive_file
        </v-icon>
        Files
        <b>({{ files ? files.length || 0 : 0 }})</b>
      </h6>
      <div>
        <v-btn
          style="float: right"
          dark
          :color="colorTheme"
          @click.stop="openUploadFileModal"
        >
          <v-icon dark>
            upload
          </v-icon>Upload
        </v-btn>
        <v-btn
          style="float: right"
          dark
          :color="colorTheme"
          @click.stop="openAddFileModal"
        >
          <v-icon dark>
            add
          </v-icon>Assign
        </v-btn>
      </div>
    </template>
    <v-data-table
      :headers="filesHeaders"
      :items="files"
      :pagination.sync="pagination"
      item-key="created_at"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            {{ props.item.category }}
          </td>
          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ props.item.fileName }}
          </td>
          <td>
            {{ props.item.usage }}
          </td>
          <td>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="warning"
                  flat
                  icon
                  v-on="on"
                  @click="download(props.item)"
                >
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
              <span>download</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :color="colorTheme"
                  flat
                  icon
                  v-on="on"
                  @click="preview(props.item)"
                >
                  <v-icon>preview</v-icon>
                </v-btn>
              </template>
              <span>preview</span>
            </v-tooltip>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :color="colorTheme"
                  flat
                  icon
                  v-on="on"
                  @click="openDeleteModal(props.item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>delete</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
    <add-file
      :dialog="isOpenAddFile"
      :color-theme="colorTheme"
      :submit-action="addFile"
      :set-usages="setUsages"
      :cancel-action="closeAddFileModal"
      :instrument="instrument"
    />
    <upload-and-assign-file
      :dialog="isOpenUploadFile"
      :submit-action="addFile"
      :cancel-action="closeUploadFileModal"
      :set-usages="setUsages"
      :color-theme="colorTheme"
      :instrument="instrument"
    />
    <v-dialog
      v-model="deleteModalOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title :class="colorTheme">
          <span class="white--text">
            Please confirm deleting this file.
          </span>
        </v-card-title>
        <v-progress-linear
          v-if="deleting"
          :color="colorTheme"
          :indeterminate="true"
          class="ma-0"
        />

        <v-form
          ref="processOrderForm"
          @submit.prevent="removeFile"
        >
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="deleteModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              :color="colorTheme"
              text="Confirm"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-expansion-panel-content>
</template>

<script>
import { mapActions } from 'vuex';
import { toQueryString } from '@/helpers';
import { Button } from '@/components/shared';
import AddFile from './AddFile';
import UploadAndAssignFile from './UploadAndAssignFile';

export default {
  name: 'FilesExpansionPanel',
  components: {
    AddFile,
    UploadAndAssignFile,
    'e-button': Button,
  },
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    instrument: {
      type: String,
      required: true,
    },
    colorTheme: {
      type: String,
      default: 'blue',
    },
    addFunction: {
      type: Function,
      required: true,
    },
    removeFunction: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      pagination: {
        page: 1,
        rowsPerPage: 25,
        sortBy: 'created_at',
        descending: true,
      },
      isOpenAddFile: false,
      isOpenUploadFile: false,
      deleting: false,
      fileToDelete: null,
      deleteModalOpen: false,
      filesHeaders: [
        {
          text: 'Category',
          align: 'left',
          value: 'category',
        },
        {
          text: 'Name',
          align: 'left',
          value: 'name',
        },
        {
          text: 'FileName',
          align: 'left',
          value: 'FileName',
        },
        {
          text: 'Usage',
          align: 'left',
          value: 'usage',
        },
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
        },
      ],
    };
  },
  methods: {
    ...mapActions(['previewFile', 'getFile', 'deleteFile']),
    addFile(data) {
      this.addFunction({
        category: data.category,
        fileName: data.fileName,
        name: data.name,
        usage: data.usage,
      });
      this.isOpenAddFile = false;
      this.isOpenUploadFile = false;
    },
    async removeFile() {
      if (this.fileToDelete) {
        this.deleting = true;
        this.removeFunction({
          category: this.fileToDelete.category,
          fileName: this.fileToDelete.fileName,
          name: this.fileToDelete.name,
          usage: this.fileToDelete.usage,
        });
      }
      this.closeDeleteModal();
    },
    openAddFileModal() {
      this.isOpenAddFile = true;
    },
    openUploadFileModal() {
      this.isOpenUploadFile = true;
    },
    openDeleteModal(file) {
      this.fileToDelete = file;
      this.deleteModalOpen = true;
    },
    closeDeleteModal() {
      this.deleting = false;
      this.fileToDelete = null;
      this.deleteModalOpen = false;
    },
    closeAddFileModal() {
      this.isOpenAddFile = false;
    },
    closeUploadFileModal() {
      this.isOpenUploadFile = false;
    },
    async preview(file) {
      this.previewFile(toQueryString({
        category: file.category,
        fileName: file.fileName,
      })).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        window.open(window.URL.createObjectURL(blob));
      });
    },
    async download(file) {
      this.previewFile(toQueryString({
        category: file.category,
        fileName: file.fileName,
      })).then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = file.fileName;
        link.click();
      });
    },
    setUsages(category) {
      switch (category) {
        case 'contract':
        case 'zeichnungsschein':
          return ['contract'];
        case 'kundeninformationen':
        case 'bond-angebotsbedingungen':
        case 'expose':
          return ['cockpit', 'mail'];
        case 'bond-wertpapierinformationsblatt':
        case 'bond-basisinformationsblatt':
        case 'bond-wertpapierprospekt':
          return ['cockpit'];
        case 'verbraucherinformationen':
        case 'kosten-nebenkosten':
        case 'agb':
          return ['mail'];
        default:
          return null;
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/financialProducts/FilesExpansionPanel.vue